
import React from 'react';
import { Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const NoDataPlaceholder: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-10 text-center">
      <Calendar className="h-12 w-12 text-hormony-coral/30 mb-4" />
      <h3 className="text-lg font-medium text-hormony-coral mb-2">
        No Period Data Available
      </h3>
      <p className="text-sm text-hormony-charcoal/70 mb-4 max-w-md">
        🔍 To see your personalized hormone chart, please update your last period start date in your profile.
      </p>
      <Button variant="coral">
        Update Period Data
      </Button>
    </div>
  );
};
